import heroImageSrc from '../../../assets/image1.jpg';
import sareeImageSrc from '../../../assets/image3.jpg';
import brandImageSrc from '../../../assets/image2.jpg';
import mensImageSrc from '../../../assets/image4.jpg';
import OccasionImageSrc from '../../../assets/image5.jpg';
import textileImageSrc from '../../../assets/image6.jpg';
import royalBlueSareeImageSrc from '../../../assets/image7.jpg';
import burgundySareeImageSrc from '../../../assets/image8.jpg';
import goldSilkSareeImageSrc from '../../../assets/image9.jpg';
import emeraldSareeImageSrc from '../../../assets/image10.jpg';
import whiteCottonDhotiImageSrc from '../../../assets/image11.jpg';
import ivorySilkVeshtiImageSrc from '../../../assets/image12.jpg';
import ivoryTraditionalShirtImageSrc from '../../../assets/image13.jpg';
import menCombinedImageSrc from '../../../assets/image14.jpg';
import marketMainImageSrc from '../../../assets/image15.jpg';
import marketSupportImage1Src from '../../../assets/image16.jpg';
import marketSupportImage2Src from '../../../assets/image17.jpg';
import marketSupportImage3Src from '../../../assets/image18.jpg';
import galleryImage1Src from '../../../assets/image19.jpg';
import galleryImage2Src from '../../../assets/image20.jpg';
import galleryImage3Src from '../../../assets/image21.jpg';
import galleryImage4Src from '../../../assets/image22.jpg';
import galleryImage5Src from '../../../assets/image23.jpg';
import galleryImage6Src from '../../../assets/image24.jpg';
import heritageImageSrc from '../../../assets/image25.jpg';
import occationWeddingImage from '../../../assets/image26.jpg';
import occationFestivalImage from '../../../assets/image27.jpg';
import occationPoojaImage from '../../../assets/image28.jpg';
import occationFamilyImage from '../../../assets/image29.jpg';
import DhotiImage from '../../../assets/image30.jpg';
import VeshtiImage from '../../../assets/image31.jpg';
import ShirtImage from '../../../assets/image32.jpg';
import DhotiShirtSetImage from '../../../assets/image33.jpg';

export const heroImage = heroImageSrc;

export const brandIntroImage = brandImageSrc;

export interface CollectionCard {
  title: string;
  subtitle: string;
  image: string;
  link: string;
}

export const collections: CollectionCard[] = [
  {
    title: 'Sarees',
    subtitle: 'Elegant traditional drapes for weddings, festivals and celebrations.',
    image: sareeImageSrc,
    link: '/collections/sarees',
  },
  {
    title: 'Men\u2019s Wear',
    subtitle: 'Traditional dhotis, veshtis and shirts inspired by South Indian heritage.',
    image: mensImageSrc,
    link: '/collections/menswear',
  },
  {
    title: 'Occasion Wear',
    subtitle: 'Traditional styles for weddings, festivals and meaningful occasions.',
    image: OccasionImageSrc,
    link: '/collections',
  },
  {
    title: 'Textiles',
    subtitle: 'Colours, fabrics and patterns rooted in Indian textile culture.',
    image: textileImageSrc,
    link: '/gallery',
  },
];

export interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  category: string;
  fabric: string;
  occasion: string;
  colours: string[];
  image: string;
}

export const products: Product[] = [
  {
    id: 'royal-blue-silk-saree',
    name: 'Royal Blue Silk Saree',
    description: 'Traditional silk saree for weddings and special occasions.',
    price: '\u00a389',
    category: 'Silk Sarees',
    fabric: 'Pure silk with zari border',
    occasion: 'Weddings and Celebrations',
    colours: ['Royal Blue', 'Gold'],
    image: royalBlueSareeImageSrc
  },
  {
    id: 'burgundy-wedding-saree',
    name: 'Deep Burgundy Wedding Saree',
    description: 'A rich traditional drape for weddings and festive evenings.',
    price: '\u00a3119',
    category: 'Silk Sarees',
    fabric: 'Silk with woven gold border',
    occasion: 'Weddings',
    colours: ['Burgundy', 'Gold'],
    image: burgundySareeImageSrc
  },
  {
    id: 'gold-silk-saree',
    name: 'Muted Gold Silk Saree',
    description: 'Soft antique gold silk with a timeless, elegant drape.',
    price: '\u00a399',
    category: 'Silk Sarees',
    fabric: 'Silk with antique gold tone',
    occasion: 'Festivals and Celebrations',
    colours: ['Gold', 'Ivory'],
    image: goldSilkSareeImageSrc
  },
  {
    id: 'emerald-georgette-saree',
    name: 'Emerald Green Georgette Saree',
    description: 'Lightweight and graceful, ideal for festive and family occasions.',
    price: '\u00a379',
    category: 'Traditional Sarees',
    fabric: 'Georgette with woven border',
    occasion: 'Festivals and Family Celebrations',
    colours: ['Emerald', 'Gold'],
    image: emeraldSareeImageSrc
  },
  {
    id: 'white-cotton-dhoti',
    name: 'Classic White Cotton Dhoti',
    description: 'A crisp traditional white dhoti for daily and ceremonial wear.',
    price: '\u00a329',
    category: 'Men\u2019s Wear',
    fabric: 'Pure cotton',
    occasion: 'Everyday and Ceremonies',
    colours: ['White'],
    image: whiteCottonDhotiImageSrc
  },
  {
    id: 'ivory-silk-veshti',
    name: 'Ivory Silk Veshti with Border',
    description: 'An elegant veshti with a rich woven border for special occasions.',
    price: '\u00a345',
    category: 'Men\u2019s Wear',
    fabric: 'Silk blend with woven border',
    occasion: 'Weddings and Festivals',
    colours: ['Ivory', 'Gold'],
    image: ivorySilkVeshtiImageSrc
  },
  {
    id: 'ivory-traditional-shirt',
    name: 'Traditional Ivory Shirt',
    description: 'A tailored traditional shirt inspired by South Indian style.',
    price: '\u00a355',
    category: 'Men\u2019s Wear',
    fabric: 'Cotton blend',
    occasion: 'Celebrations and Festivals',
    colours: ['Ivory', 'White'],
    image: ivoryTraditionalShirtImageSrc
  },
  {
    id: 'dhoti-shirt-set',
    name: 'Dhoti + Shirt Combination Set',
    description: 'A coordinated traditional set for weddings and family occasions.',
    price: '\u00a389',
    category: 'Men\u2019s Wear',
    fabric: 'Cotton and silk blend',
    occasion: 'Weddings and Celebrations',
    colours: ['Ivory', 'Gold'],
    image: menCombinedImageSrc
  },
];

export interface PriceRow {
  label: string;
  price: string;
}

export const priceGuide: PriceRow[] = [
  { label: 'Traditional Sarees', price: 'From \u00a349' },
  { label: 'Silk Sarees', price: 'From \u00a389' },
  { label: 'Dhoti / Veshti', price: 'From \u00a325' },
  { label: 'Traditional Shirts', price: 'From \u00a345' },
  { label: 'Complete Sets', price: 'From \u00a379' },
];

export const marketMainImage = marketMainImageSrc;
export const marketSupportImages = [
  marketSupportImage1Src,
  marketSupportImage2Src,
  marketSupportImage3Src,
];

export interface GalleryItem {
  label: string;
  image: string;
  tall?: boolean;
}

export const galleryItems: GalleryItem[] = [
  {
    label: 'The Collection',
    tall: true,
    image: galleryImage1Src,
  },
  {
    label: 'The Market',
    image: galleryImage2Src
  },
  {
    label: 'The Textiles',
    image: galleryImage3Src
  },
  {
    label: 'The People',
    tall: true,
    image: galleryImage4Src
  },
  {
    label: 'The Experience',
    image: galleryImage5Src
  },
  {
    label: 'The Details',
    image: galleryImage6Src
  },
];

export const heritageImage = heritageImageSrc;

export interface Occasion {
  title: string;
  subtitle: string;
  image: string;
}

export const occasions: Occasion[] = [
  {
    title: 'Weddings',
    subtitle: 'Traditional elegance for unforgettable celebrations.',
    image: occationWeddingImage
  },
  {
    title: 'Festivals',
    subtitle: 'Colour, tradition and celebration.',
    image: occationFestivalImage
  },
  {
    title: 'Pooja and Cultural Occasions',
    subtitle: 'Traditional clothing for meaningful moments.',
    image: occationPoojaImage
  },
  {
    title: 'Family Celebrations',
    subtitle: 'Styles that bring generations together.',
    image: occationFamilyImage
  },
];

export interface MenswearItem {
  title: string;
  description: string;
  image: string;
}

export const menswearItems: MenswearItem[] = [
  {
    title: 'Dhoti',
    description: 'The classic traditional wrap worn for ceremonies and celebrations.',
    image: DhotiImage
  },
  {
    title: 'Veshti',
    description: 'Elegant silk-blend veshti with a rich woven border for special days.',
    image: VeshtiImage
  },
  {
    title: 'Traditional Shirt',
    description: 'Tailored shirts inspired by South Indian heritage styling.',
    image: ShirtImage
  },
  {
    title: 'Dhoti + Shirt Set',
    description: 'A coordinated set for weddings, festivals and family occasions.',
    image: DhotiShirtSetImage
  },
];

export const phone = '07909 324302';
export const phoneHref = 'tel:+447909324302';
export const whatsappHref = 'https://wa.me/447909324302';
export const emailPlaceholder = 'hello@srmtextiles.co.uk';